module.exports = __webpack_public_path__ + "static/media/documents-icon.e923b382.svg";